import React, { useState, useEffect, useContext, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import {
  enableBackupPlanStart,
  disableBackupPlanStart,
  deleteBackupPlanStart,
  setCleanBackupPlanCache,
  resetLoadingSettings
} from "store/actions";

import { LayoutContext } from "App/common/hoc/Layout";
import Tooltip from "App/common/ui/Tooltip";

function HeaderButtons(props) {
  const { lMethods, lState } = useContext(LayoutContext);
  const [enable, setEnable] = useState(false);
  const [removeDelete, setRemoveDelete] = useState(false);
  const lStateRef = useRef();

  /*****************************Handling  popup using enter key ***************************/
  useEffect(() => {
    lStateRef.current = lState;
    const handleKeyDown = event => {
      if (
        event.key === "Enter" &&
        lStateRef.current.popup.show &&
        lStateRef.current.popup.params.popupType === "header"
      ) {
        if (lStateRef.current.popup.alertName === "disableBackupPlan") {
          lStateRef.current.popup.params.execute();

          lMethods.closePopup();
          //assigning checklist to empty
          props.backupPlan.backupPlans.checkList = [];
        } else if (lStateRef.current.popup.alertName === "enableBackupPlan") {
          lStateRef.current.popup.params.execute();

          lMethods.closePopup();
          //assigning checklist to empty
          props.backupPlan.backupPlans.checkList = [];
        } else if (
          lStateRef.current.popup.alertName === "deleteBackupPlan" &&
          !lStateRef.current.popup.params.disable
        ) {
          lStateRef.current.popup.params.execute();

          lMethods.closePopup();
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    // Cleanup: Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [lState]);

  const getAllDevices = checklist => {
    const devices = [];
    checklist.forEach(list =>
      devices.push(props.backupPlan.backupPlans.data[list].devices)
    );
    return devices.flat(1);
  };

  useEffect(() => {
    if (
      props.backupPlan.backupPlans.checkList &&
      props.backupPlan.backupPlans.checkList.length !== 0
    ) {
      let findStatus = Object.keys(
        props.backupPlan.backupPlans.data
      ).filter(plan =>
        props.backupPlan.backupPlans.checkList.includes(
          props.backupPlan.backupPlans.data[plan].planId
        )
      );
      let ActiveStatus = findStatus.filter(
        plan =>
          props.backupPlan.backupPlans.data[plan].status ===
          props.enums.BackupPlanStatus.ACTIVE
      );
      setRemoveDelete(props.backupPlan.backupPlans.checkList.includes(1));
      if (findStatus.length === ActiveStatus.length) setEnable(false);
      else setEnable(true);
    } else {
      setRemoveDelete(false);
    }
  }, [props.backupPlan]);

  return (
    <div className="main_header_title">
      <div className="btn_blk">
        {
          <Tooltip
            {...(props.backupPlan.defaultPlanDetails
              ? { title: "Create Plan", placement: "top" }
              : {})}
          >
            <div
              className={[
                "common_btn openCreateplan",
                props.backupPlan.defaultPlanDetails ? "" : "disabled"
              ].join(" ")}
              onClick={() => {
                if (props.backupPlan.defaultPlanDetails) {
                  lMethods.openSlidingPopup("backupPlan", "createNewPlan", {
                    planID: 1,
                    isNew: true
                  });
                  props.setCleanBackupPlanCache("defaultPlanDetails");
                  props.resetLoadingSettings();
                }
              }}
            >
              <span className="svg_wrap">
                <svg
                  x="0px"
                  y="0px"
                  viewBox="0 0 12 12"
                  style={{ enableBackground: "new 0 0 12 12" }}
                  xmlSpace="preserve"
                >
                  <g>
                    <path className="crp0" d="M12,5v2H0V5H12z" />
                    <path className="crp0" d="M5,0h2v12H5V0z" />
                  </g>
                </svg>
              </span>
              <p className="nowrap">Create Plan</p>
            </div>
          </Tooltip>
        }
        <div className="btn_grp">
          {!enable && (
            <Tooltip {...{ title: "Disable Plan", placement: "top" }}>
              <div
                className={`common_btn openDisable_popup ${
                  props.backupPlan.backupPlans.checkList &&
                  props.backupPlan.backupPlans.checkList.length !== 0
                    ? ""
                    : "disabled"
                }`}
                onClick={() =>
                  props.backupPlan.backupPlans.checkList &&
                  props.backupPlan.backupPlans.checkList.length !== 0
                    ? lMethods.openPopup("disableBackupPlan", {
                        execute: () => {
                          props.disableBackupPlanStart({
                            planIDs: props.backupPlan.backupPlans.checkList,
                            devices: getAllDevices(
                              props.backupPlan.backupPlans.checkList
                            ),
                            log: JSON.stringify({
                              mode: "backupPlan",
                              params: {
                                action: "disabled"
                              }
                            })
                          });
                          lMethods.closePopup();
                          //assigning checklist to empty
                          props.backupPlan.backupPlans.checkList = [];
                        },
                        popupType: "header"
                      })
                    : null
                }
              >
                <span className="svg_wrap">
                  <svg
                    x="0px"
                    y="0px"
                    viewBox="0 0 18 18"
                    style={{ enableBackground: "new 0 0 18 18" }}
                    xmlSpace="preserve"
                  >
                    <path
                      className="crd0"
                      d="M13.26,4.68c-2.13-2.13-5.43-2.33-7.8-0.64l8.44,8.44C15.59,10.12,15.39,6.81,13.26,4.68z M4.68,13.27
          c2.13,2.13,5.44,2.33,7.81,0.63L4.04,5.46C2.35,7.83,2.55,11.14,4.68,13.27z M14.69,14.7c-3.15,3.14-8.24,3.14-11.39,0
          c-3.14-3.15-3.14-8.24,0-11.39c3.15-3.14,8.24-3.14,11.39,0C17.84,6.45,17.84,11.55,14.69,14.7z"
                    />
                  </svg>
                </span>
                <p className="nowrap">Disable</p>
              </div>
            </Tooltip>
          )}
          {enable && (
            <Tooltip {...{ title: "Enable Plan", placement: "top" }}>
              <div
                className={`common_btn openEnable_popup ${
                  props.backupPlan.backupPlans.checkList &&
                  props.backupPlan.backupPlans.checkList.length !== 0
                    ? ""
                    : "disabled"
                }`}
                onClick={() =>
                  props.backupPlan.backupPlans.checkList &&
                  props.backupPlan.backupPlans.checkList.length !== 0
                    ? lMethods.openPopup("enableBackupPlan", {
                        execute: () => {
                          props.enableBackupPlanStart({
                            planIDs: props.backupPlan.backupPlans.checkList,
                            devices: getAllDevices(
                              props.backupPlan.backupPlans.checkList
                            ),
                            log: JSON.stringify({
                              mode: "backupPlan",
                              params: {
                                action: "enabled"
                              }
                            })
                          });
                          lMethods.closePopup();
                          //assigning checklist to empty
                          props.backupPlan.backupPlans.checkList = [];
                        },
                        popupType: "header"
                      })
                    : null
                }
              >
                <span className="svg_wrap">
                  <svg
                    x="0px"
                    y="0px"
                    viewBox="0 0 17.26 17.26"
                    style={{ enableBackground: "new 0 0 17.26 17.26" }}
                    xmlSpace="preserve"
                  >
                    <g
                      id="Group_4"
                      transform="translate(-4.243 5.657) rotate(-45)"
                    >
                      <g id="Group_17">
                        <rect
                          id="Rectangle_97"
                          x="1.09"
                          y="10.95"
                          transform="matrix(-1 2.535182e-06 -2.535182e-06 -1 17.1834 24.9085)"
                          className="cre0"
                          width={15}
                          height={3}
                        />
                        <rect
                          id="Rectangle_98"
                          x="1.09"
                          y="5.95"
                          transform="matrix(-1 2.535181e-06 -2.535181e-06 -1 5.1834 19.9085)"
                          className="cre0"
                          width={3}
                          height={8}
                        />
                      </g>
                    </g>
                  </svg>
                </span>
                <p className="nowrap">Enable</p>
              </div>
            </Tooltip>
          )}
          {!removeDelete && (
            <Tooltip {...{ title: "Delete Plan", placement: "top" }}>
              <div
                className={`common_btn openDelete_popup ${
                  props.backupPlan.backupPlans.checkList &&
                  props.backupPlan.backupPlans.checkList.length !== 0
                    ? ""
                    : "disabled"
                }`}
                onClick={() =>
                  props.backupPlan.backupPlans.checkList &&
                  props.backupPlan.backupPlans.checkList.length !== 0
                    ? lMethods.openPopup("deleteBackupPlan", {
                        execute: () => {
                          props.deleteBackupPlanStart({
                            planIDs: props.backupPlan.backupPlans.checkList,
                            devices: getAllDevices(
                              props.backupPlan.backupPlans.checkList
                            ),
                            log: JSON.stringify({
                              mode: "backupPlan",
                              params: {
                                action: "deleted"
                              }
                            })
                          });
                          lMethods.closePopup();
                        },

                        disable: true,
                        popupType: "header"
                      })
                    : null
                }
              >
                <span className="svg_wrap">
                  <svg
                    x="0px"
                    y="0px"
                    viewBox="0 0 14 16"
                    style={{ enableBackground: "new 0 0 14 16" }}
                    xmlSpace="preserve"
                  >
                    <path
                      className="cpd0"
                      d="M5,5h1v7H5V5z M8,5h1v7H8V5z M10.99,4c0-0.55-0.44-0.99-0.98-1H4C3.45,3.01,3.01,3.45,3.01,4V13
          c0,0.55,0.45,1,1,1h5.97c0.55,0,1-0.45,1-1V4z M13,3v11c0,1.1-0.9,2-2,2H3c-1.11,0-2-0.9-2-2V3H0V1h3h2V0h4v1h2h3v2H13z"
                    />
                  </svg>
                </span>
                <p className="nowrap">Delete</p>
              </div>
            </Tooltip>
          )}
        </div>
      </div>
      <p className="srchResult" style={{ display: "none" }}>
        <span className="back_btn" title="Click to exit search" />
        <span>Search results for test</span>
      </p>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    backupPlan: state.backupPlan,
    enums: state.common.enums
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setCleanBackupPlanCache,
      enableBackupPlanStart,
      disableBackupPlanStart,
      deleteBackupPlanStart,
      resetLoadingSettings
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderButtons);
